import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Typology } from 'types';
import TypologyTable from '../../components/templates/typology-table';
import ButtonPrimary from '../../components/molecules/button-primary';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import {
  UserInfoSelectors,
  TypologyActions,
  TypologySelectors,
  OtherSelectionActions,
  productCodesActions,
  ClearStateSliceActions,
} from '../../common/config/store';
import { StyledMainTitle, StyledListUtil } from '../../common/styling/mixins';
import history from '../../app-router/history';
import ModalContentConfirm from '../../components/organisms/modal-content-confirm';
import { isRequestError } from 'common/utils/error';
import MessageModal from '../../components/organisms/message-modal';

const { StyledListWrapper, StyledListTitleWrapper, StyledListButtonWrapper, StyledListBoldWrapper } = StyledListUtil;

const Typologies: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const [typology, setTypology] = useState({ id: 0, name: '' });
  const [modalVisible, setModalVisible] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const canWriteTypologies = useSelector(UserInfoSelectors.hasWriteAccess('Typologies'));
  const error = useSelector(TypologySelectors.errorSelector);
  const errorType = useSelector(TypologySelectors.errorTypeSelector);
  useEffect(() => {
    dispatch(OtherSelectionActions.fetchTypologies());
    dispatch(productCodesActions.fetchProductCodes());
    dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Typology' }));
  }, [dispatch]);
  useEffect(() => {
    if (errorType && errorType === 'delete') setShowDeleteModal(true);
  }, [errorType]);

  const onDeleteHandler = (typo: Typology): void => {
    setTypology({ id: typo?.id, name: typo?.name });
    setModalVisible(true);
  };
  const onModalConfirm = (shouldRemove: boolean) => {
    if (shouldRemove) {
      dispatch(TypologyActions.deleteTypology(typology?.id.toString()));
    }
    setModalVisible(false);
  };
  const onClickCreateHandler = (): void => {
    history.push(`/typology`);
  };
  const onClickEditHandler = (typo: Typology): void => {
    return history.push(`/typology/${typo?.id}`);
  };
  return (
    <div>
      <Modal
        title={t('Modal', 'REASON_MODAL_TITLE')}
        footer={null}
        open={modalVisible}
        onCancel={() => onModalConfirm(false)}
      >
        <ModalContentConfirm
          title={
            <div>
              {t('Modal', 'TYPOLOGY_DELETE_CONFIRM')}
              <StyledListBoldWrapper>{typology?.name}</StyledListBoldWrapper>
            </div>
          }
          onConfirm={onModalConfirm}
        />
      </Modal>

      <MessageModal
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Typology' }));
        }}
        errorMessage={error && isRequestError(error) ? undefined : error}
      />
      <Layout />
      <StyledListWrapper>
        <StyledListTitleWrapper>
          <StyledMainTitle>{t('TypologyPage', 'TYPOLOGY_REPOSITORY_PAGE_H2')}</StyledMainTitle>
          <StyledListButtonWrapper>
            {canWriteTypologies && (
              <ButtonPrimary onClick={onClickCreateHandler}>{t('Buttons', 'ADD_TYPOLOGY')}</ButtonPrimary>
            )}
          </StyledListButtonWrapper>
        </StyledListTitleWrapper>
        <TypologyTable canWrite={canWriteTypologies} onClickEdit={onClickEditHandler} onClickDelete={onDeleteHandler} />
      </StyledListWrapper>
    </div>
  );
};

export default Typologies;
